module.exports = __webpack_public_path__ + "static/media/taotu.dfefd2d4.png";